export default __webpack_public_path__ + "static/photoshoot_3-69cdf8b163234e2c11d378d0d195f5df.png";